export const DOCUMENT_ROUTE = '/reports/$reportId/documento' as const;
